import { FaGithub, FaLinkedin, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { SiUpwork } from "react-icons/si";

const ContactData = {
  phone: "+91 6263851934",
  email: "yoverma987@gmail.com",
  address: "Indore, Madhya Pradesh, India",
  links: [
    {
      url: "https://github.com/YR55",
      icon: FaGithub,
    },
    {
      url: "https://linkedin.com/in/yogesh-verma-b962a224a",
      icon: FaLinkedin,
    },
    {
      url: "https://www.upwork.com/freelancers/~01d7340684cc85b148?mp_source=share",
      icon: SiUpwork,
    },
    {
      url: "https://www.instagram.com/yogesh08_verma",
      icon: FaInstagram,
    },
    {
      url: "https://x.com/Yogesh_verma_97",
      icon: FaXTwitter,
    },
  ],
};

export default ContactData;
